import { render, staticRenderFns } from "./sidebarOptions.vue?vue&type=template&id=01121784"
import script from "./sidebarOptions.vue?vue&type=script&lang=js"
export * from "./sidebarOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports